var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3212_19684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.687595 11.5C0.687595 17.471 5.52806 22.3114 11.4991 22.3114C17.4701 22.3114 22.3105 17.471 22.3105 11.5C22.3105 5.52894 17.4701 0.688477 11.4991 0.688477C5.52806 0.688477 0.687595 5.52894 0.687595 11.5Z",
    stroke: "#2A2D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6517 6.16737L15.7552 4.23575C15.582 4.12022 15.3479 4.16702 15.2323 4.34027L13.0672 7.58689C12.9516 7.76014 12.9984 7.99425 13.1717 8.10978L15.3113 9.53669C15.5814 9.7168 15.7059 10.0495 15.6204 10.3626L15.5554 10.6009C15.0614 12.4111 13.9936 14.0123 12.5123 15.164L12.3173 15.3157C12.061 15.5149 11.706 15.5278 11.436 15.3477L9.29634 13.9208C9.12313 13.8053 8.88902 13.8521 8.77345 14.0253L6.60832 17.272C6.49279 17.4452 6.53955 17.6793 6.7128 17.7949L9.60929 19.7265C10.5459 20.3511 11.7993 20.192 12.5502 19.3531L15.9051 15.6046C16.4532 14.9922 16.9114 14.3052 17.2661 13.5639L19.4373 9.02593C19.9232 8.01035 19.5884 6.79203 18.6517 6.16737Z",
    fill: "#2A2D34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82031 12.4201C7.82031 12.4201 7.82031 10.6508 8.88559 9.41238C9.95087 8.17393 11.5003 7.82007 11.5003 7.82007",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59961 11.9601C4.59961 11.9601 4.59961 9.3062 6.19751 7.44851C7.7954 5.59083 10.1196 5.06006 10.1196 5.06006",
    stroke: "#2A2D34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3212_19684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c7e0f07f84a4c2056a011cc9274cb342.svg";
export { ForwardRef as ReactComponent };